require('./okDiscountBody.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const classNames = require('classnames');
// @commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { FormattedText, formatText } = require('core/i18n').i18n;

const { OKLink } = require('commonsComponents/OKLink');
// @ helpers
const { getPublicSiteUrl } = require('core/apiURLBuilder');
// @components
const OkDiscountSuccessMessage = require('components/okDiscount/okDiscountSuccessMessage/okDiscountSuccessMessage');
const OkDiscountProductBox = require('components/okDiscount/okDiscountProductBox/okDiscountProductBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @constants
const { OKDISCOUNT_STATUS_ALREADY_ADDED } = require('constants/index');
// @utilities
const {
    PROC_DISCOUNTS,
    recordLink,
} = require('utilities/tagging');

class OkDiscountBody extends React.Component {
    constructor(props) {
        super(props);

        this.handleClickBackToDiscounts = this.handleClickBackToDiscounts.bind(this);
    }

    handleClickBackToDiscounts() {
        const eventTag = this.props.immOkDiscount.getIn(['okDiscountDetail','discount', 'breadcrumbTitle']);
        recordLink(PROC_DISCOUNTS, 'volver a descuentos', eventTag);
    }

    render() {
        const {
            country,
            immFlagBasedFeatures,
            immGlobalVariables,
            immOkDiscount,
            inProgress,
            isLoading,
            isModalOpen,
            requestExternalCode,
            requestReferralPromotionDiscount,
            userDiscountStatus
        } = this.props;

        if (isLoading || inProgress) {
            return (<LoadingSection />);
        }
        const publicSiteUrl = getPublicSiteUrl(country);
        const publicDiscountLink = `${publicSiteUrl}/${formatText("linkBack-discounts")}`;
        const email = immOkDiscount.get('email');
        const submitSuccessful = immOkDiscount.get('submitSuccessful');
        const okDiscountBoddyBlurClasses = classNames('col-xs-12', {
            'okdiscount-body__blur': isModalOpen
        });
        let okDiscountSuccessMessage;

        if (userDiscountStatus !== OKDISCOUNT_STATUS_ALREADY_ADDED && submitSuccessful) {
            okDiscountSuccessMessage =   <OkDiscountSuccessMessage email={email} />;
        }

        return (
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row no-outside-gutter grid-view--content-position-negative okdiscount-body__content-position-negative">
                        <div className={okDiscountBoddyBlurClasses}>
                            <OKSectionBox className="okdiscount-body__container">
                                {okDiscountSuccessMessage}
                                <OkDiscountProductBox
                                    immFlagBasedFeatures={immFlagBasedFeatures}
                                    immGlobalVariables={immGlobalVariables}
                                    immOkDiscount={immOkDiscount}
                                    requestExternalCode={requestExternalCode}
                                    requestReferralPromotionDiscount={requestReferralPromotionDiscount}
                                />
                                <hr className="okdiscount-body__divisor" />
                                <div className="okdiscount-body__footer pull-right">
                                    <OKLink
                                        to={publicDiscountLink}
                                        onClick={this.handleClickBackToDiscounts}
                                        modifier="complementary"
                                    >
                                        <FormattedText value="OKDiscounts-backToOKDiscountsPlan" />
                                    </OKLink>
                                </div>
                            </OKSectionBox>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

OkDiscountBody.defaultProps = {
    isLoading: false,
    inProgress: false,
    isModalOpen: false,
    userDiscountStatus: '',
}

OkDiscountBody.propTypes = {
    isModalOpen: PropTypes.bool.isRequired,
    immOkDiscount: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    inProgress: PropTypes.bool.isRequired,
    requestExternalCode: PropTypes.func.isRequired,
    requestReferralPromotionDiscount: PropTypes.func.isRequired,
    userDiscountStatus: PropTypes.string,
    country: PropTypes.string,
};

module.exports = OkDiscountBody;
